// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f1f8f295","727":"841becf9"}[chunkId] + ".chunk.js";
};